/* BackupTypeComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./BackupTypeRenderer");
const _ = require("lodash");

class BackupTypeComponent extends EventEmitter {
    constructor(
        logger,
        userSession,
        activeView,
        selectedDeviceIds,
        supportedDevices,
        unsupportedDevices,
        deviceEntity,
        modalUserFeedback,
        supportedOsList,
        selection
    ) {
        super();
        this._titleText = "Restore Devices";
        this._logger = logger;
        this._userSession = userSession;
        this._activeView = activeView;
        this._selectedDeviceIds = selectedDeviceIds;
        this._DeviceEntity = deviceEntity;
        this._modalUserFeedback = modalUserFeedback;
        this._supportedOsList = supportedOsList;
        this._supportedDevices = supportedDevices;
        this._unsupportedDevices = unsupportedDevices;
        this._selection = selection;
        this._renderer = new Renderer(this);

        this.reject = this.reject.bind(this);
        this.resolve = this.resolve.bind(this);

        this._registerListeners();
        this._renderer.render();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    get titleText() {
        return this._titleText;
    }

    get logger() {
        return this._logger;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "BackupTypeComponent.shutdown() error");
            }
        );
    }

    cancelAction() {
        let err = new Error("user rejected");
        err.userRejected = true;
        return this.reject(err);
    }

    reject(err) {
        this._context.reject(err);
    }
    resolve(action) {
        this._context.resolve(action);
    }

    // prettier-ignore
    set "$teve.ui.context" (context) { //jshint ignore:line
        this._context = context;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    /**
     * Create workTarget Object from devices component selection
     * @param {String} selection
     * @returns {Object}
     */
    _getWorkTarget(selection) {
        let workTarget;
        switch (selection) {
            case "all":
                workTarget = {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: {},
                };
                break;
            case "selection":
                workTarget = {
                    category: "entity",
                    entityType: "Device",
                    method: "multi",
                    ids: this._activeView.getSelectedDeviceIds().selectedRows,
                };
                break;
            case "apply_current_filter":
                workTarget = {
                    entityType: "Device",
                    category: "entity",
                    method: "query",
                    query: !_.isEmpty(
                        _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery")
                    )
                        ? _.get(this._activeView._userGridData.getBasicSearchData(), "filterQuery")
                        : this._activeView._userGridData.getAdvancedSearchData(),
                };
                break;
        }
        return workTarget;
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BackupTypeComponent;
